import React from 'react';
import './index.scss';
import { Icon } from 'semantic-ui-react';

const MessageBanner = ({ text = '', style = {}, link = null, closable = false, onClose = null }) => {
    return (
        <div className={`MessageBanner`} style={style}>
            <span className='MessageBanner__text'>{text}</span>
            {link && <a href={link} className='MessageBanner__link' target='_blank' rel='noreferrer'> Click Here</a>}
            {closable && <Icon
                className="fa-solid fa-xmark MessageBanner__close"
                onClick={onClose}
            />}
        </div>
    )
}

export default MessageBanner;
